import React, { useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { createPortal } from "react-dom";

import "./style.scss";

const Toaster = ({ message, type }) => {
  const toastCount = useRef(0);

  useEffect(() => {
    if (message) {
      toast.dismiss();

      setTimeout(() => {
        toastCount.current += 1;
        toastTypes[type](message, {
          ...style,
          toastId: `toast-${toastCount.current}`,
        });
      }, 100);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, type, toastCount.current]);

  return createPortal(
    <ToastContainer data-test="toast-container" />,
    document.body,
  );
};

export default Toaster;

const toastTypes = {
  success: (args) => toast.success(args),
  info: (args) => toast.info(args),
  warn: (args) => toast.warn(args),
  error: (args) => toast.error(args),
};

const style = {
  position: "top-center",
  autoClose: 7000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  style: {
    zIndex: 9999,
  },
};
